var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.items,"item-text":"text","item-value":"value","label":_vm.$t('message.filter_month'),"clearable":"","outlined":"","dense":""},on:{"input":(event) => {
      _vm.emitChange(event);
    }},model:{value:(_vm.selectedItem),callback:function ($$v) {_vm.selectedItem=$$v},expression:"selectedItem"}})
}
var staticRenderFns = []

export { render, staticRenderFns }